<template>
  <v-card width="500" class="mx-auto mt-5">
    <v-card-title>
      <h1 class="display-1">Inicio de sesión</h1>
    </v-card-title>
    <v-card-text>
      <v-form>
        <v-text-field
          label="email"
          id="email"
          v-model="email"
          @input="
            v => {
              email = v.toLowerCase();
            }
          "
        />
        <v-text-field
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
          :type="showPassword ? 'text' : 'password'"
          label="Contraseña"
          id="Password"
          v-model="password"
        />
      </v-form>
    </v-card-text>
    <v-card-actions class="d-flex flex-column">
      <v-btn
        color="success"
        class="ma-2"
        block
        :outlined="$vuetify.breakpoint.mdAndUp"
        @click="LogIn"
      >
        Ingresar
      </v-btn>
      <v-btn
        color="info"
        class="ma-2"
        block
        :outlined="$vuetify.breakpoint.mdAndUp"
        @click="Register('register')"
      >
        Registrarse
      </v-btn>
      <v-btn
        color="warning"
        class="ma-2"
        block
        :outlined="$vuetify.breakpoint.mdAndUp"
        @click="Register('forgotPassword')"
      >
        Olvidó Su Contraseña
      </v-btn>
      <v-btn
        color="primary"
        class="ma-2"
        block
        :outlined="$vuetify.breakpoint.mdAndUp"
        @click="supportMailToClipBoard()"
      >
        <v-icon class="pa-2">
          mdi-content-copy
        </v-icon>
        soporte.clon@limagrain.com
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "Login",

  components: {
    //
  },

  data: () => ({
    showPassword: false,
    email: null,
    password: null,
    errors: 0,
    error: null
  }),

  methods: {
    async LogIn() {
      await this.$bRoot.auth.login(this.email, this.password);
      if (!this.$bRoot.errors) {
        this.$router.push({ name: "Home" });
      }
    },

    async Register(args) {
      try {
        await this.$bRoot.auth.logout();
      } finally {
        this.$router.push({ name: "Register", params: { mode: args } });
      }
    },

    async supportMailToClipBoard() {
      try {
        await navigator.clipboard.writeText("soporte.clon@limagrain.com");
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    },

    onError(error) {
      this.error = error;
      this.errors += 1;
    }
  },

  mounted() {
    this.$bRoot.errors = null;
    this.email = this.$bRoot.auth.email;
  }
};
</script>
